import {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { TUserAuth } from "../types";
import { v4 } from "uuid";
import { ChatService } from "../APIService/ChatService";

export type TAuthContext = {
  isAuth: boolean;
  authInfo: TUserAuth;
  setIsAuth: Dispatch<SetStateAction<boolean>>;
  studentId: number;
  setStudentId: Dispatch<SetStateAction<number>>;
};

export const AuthContext = createContext<TAuthContext>({
  isAuth: false,
  authInfo: {
    id: 0,
    email: "",
    access: "",
    role: "",
    iat: 0,
    exp: 0,
  },
  setIsAuth: () => {},
  studentId: 0,
  setStudentId: () => {},
});

export function authObj(): TUserAuth {
  let auth = localStorage.getItem("auth");
  if (!auth) {
    localStorage.setItem("auth", '{"id": "' + v4() + '"}');
    auth = localStorage.getItem("auth");
  }
  return JSON.parse(auth!);
}

// TODO: get rid of it. Get this info from the localStorage or JWT token
function AuthProvider(props: { children: any }) {
  const [isAuth, setIsAuth] = useState(false);
  const [userInfo, setUserInfo] = useState<TUserAuth>({
    id: 0,
    email: "",
    access: "",
    role: "",
    iat: 0,
    exp: 0,
  });
  const [studentId, setStudentId] = useState(0);

  useEffect(() => {
    const auth = localStorage.getItem("auth");
    if (auth && !isNaN(Number(JSON.parse(auth).id))) {
      setIsAuth(true);
      setUserInfo(JSON.parse(auth));
      setStudentId(userInfo.id as number);
    } else {
      setIsAuth(false);
      setStudentId(0);
      if (!auth) {
        localStorage.setItem("auth", '{"id": "' + v4() + '"}');
      }
    }
  }, [isAuth, userInfo.id]);

  return (
    <AuthContext.Provider
      value={{ isAuth, setIsAuth, authInfo: userInfo, studentId, setStudentId }}
    >
      {props.children}
    </AuthContext.Provider>
  );
}

export default AuthProvider;
export const useAuthContext = () => {
  return useContext(AuthContext);
};
